import React from "react";

import styled from "styled-components/macro";

import { faClock } from "@fortawesome/pro-solid-svg-icons";

import { FnrPopover } from "UI/FnrPopover2";

import HistoryPopoverContent from "./HistoryPopoverContent";
import HoverButton from "./HoverButton";

export default function UserSignupHistoryButton({
  userSignupHistory,
  isHovering,
  showHistoryPopover,
  setShowHistoryPopover,
  signupItemID,
  user,
}) {
  const historyRef = React.useRef();

  const hasUserSignupHistory = Boolean(
    userSignupHistory && userSignupHistory.length
  );

  const handleHistoryClick = () => {
    setShowHistoryPopover(!showHistoryPopover);
  };

  const hidePopover = () => {
    setShowHistoryPopover(false);
  };

  if (!hasUserSignupHistory) return null;

  return (
    <Wrapper ref={historyRef}>
      <HoverButton
        icon={faClock}
        isHovering={isHovering || showHistoryPopover}
        isActive={showHistoryPopover}
        onClick={handleHistoryClick}
      />

      <FnrPopover
        show={showHistoryPopover}
        buttonRef={historyRef}
        onShouldClose={() => setShowHistoryPopover(false)}
        style={{ width: 260 }}
      >
        <HistoryPopoverContent
          historyData={userSignupHistory}
          respondentInfo={{
            ID: user.userID,
            fname: user.fname,
            lname: user.lname,
          }}
          signupItemID={signupItemID}
          totalAmountPaid={user?.totalAmountPaid}
          hidePopover={hidePopover}
        />
      </FnrPopover>
    </Wrapper>
  );
}

const Wrapper = styled.div``;
